import { RouteRecordNameGeneric } from 'vue-router'
import {
  permissions as allPermissions,
  routePermissions,
} from '~/constants/permissions'
import {
  systemAdminPermissions,
  userPermissions,
} from '~/constants/user-permissions'
import { Role } from '~/types/users'
import { getUserRoles } from '~/utils/token'

export function usePermissions() {
  const userRoles = getUserRoles()

  function getPermissionsForRole(role: Role): string[] {
    const perms = userPermissions[role] || []
    if (role === Role.SYSTEM_ADMIN) {
      return [...perms, ...systemAdminPermissions]
    }
    return perms
  }

  const permissions = Array.from(
    new Set(userRoles.flatMap(getPermissionsForRole)),
  )

  const hasPermission = (permission: string) => {
    return permissions.includes(permission)
  }

  function hasRoutePermission(routeName: RouteRecordNameGeneric) {
    const key = typeof routeName === 'string' ? routeName : ''
    const permissions = routePermissions[key] || []
    return permissions.some((permission: string) => hasPermission(permission))
  }

  return { hasPermission, hasRoutePermission, permissions: allPermissions }
}
